import { hooks, log } from '@atlassian/mpac-utils';
import { toSPIInstallableAddonIdentifier } from '../../../../records/InstallableAppIdentifier';
import { getAppRequestedStatus } from '../../../../services/AppRequests';
import { getCloudIdFromHostInfo } from '../../../../services/HostInfoApi';
import getSPI from '../../../../services/SPI';
import { getInstallableApp } from '../../../AppInstallDialog/utils/installableApp';
import { getAppHeaderDetails } from '../../utils';
function useAppRequestBaseData(config, hostInfo, user, appKey) {
  const {
    usePromise
  } = hooks;
  const productName = hostInfo === null || hostInfo === void 0 ? void 0 : hostInfo.product;
  const cloudId = productName && getCloudIdFromHostInfo(hostInfo);
  const userId = user === null || user === void 0 ? void 0 : user.atlassianAccountId;
  const runPromise = !!(cloudId && userId);
  const {
    result,
    error,
    pending
  } = usePromise(async () => {
    const hostPricingPromise = getSPI().getHostPricingInfo();
    const appRequestStatusParams = {
      cloudId,
      productName,
      appKey,
      userId
    };
    const appRequestStatusPromise = getAppRequestedStatus(appRequestStatusParams).catch(error_ => {
      if (error_.status !== 404) {
        console.log('failed to fetch app request status');
      }
      return null;
    });
    const appDetailsPromise = getAppHeaderDetails(config.graphQLGatewayUrl, appKey);
    const identifier = await getInstallableApp(config.graphQLGatewayUrl, appKey);
    const appInstallStatusPromise = getSPI().getInstalledAddon({
      contextId: hostInfo === null || hostInfo === void 0 ? void 0 : hostInfo.globalContext.id,
      addon: toSPIInstallableAddonIdentifier(identifier)
    });
    const [hostPricing, appInstallStatus, appRequestStatus, appDetails] = await Promise.all([hostPricingPromise, appInstallStatusPromise, appRequestStatusPromise, appDetailsPromise]);
    return {
      hostPricing,
      appInstallStatus,
      appRequestStatus,
      appDetails
    };
  }, [runPromise], runPromise);
  if (error) {
    log.error('useAppRequestBaseData', "Failed to retrieve app request base data", {
      error
    });
  }
  return {
    pending,
    error,
    result
  };
}
export { useAppRequestBaseData };